const toPositiveInteger = (value: number, fallback: number): number =>
  Number.isFinite(value) && value >= 1 ? Math.floor(value) : fallback;

export default toPositiveInteger;
